"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownList = void 0;
var dropdown_list_1 = require("@csod/dropdown-list");
Object.defineProperty(exports, "DropdownList", { enumerable: true, get: function () { return dropdown_list_1.DropdownList; } });

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["DropdownList"] = undefined;


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/2c51a2fe812ded8e/src/.tmp/DropdownList/DropdownList.js
// module id = 60
// module chunks = 0 1